import { render } from "./CampusButton.vue?vue&type=template&id=3c0f3b2f&scoped=true&ts=true"
import script from "./CampusButton.vue?vue&type=script&lang=ts"
export * from "./CampusButton.vue?vue&type=script&lang=ts"

import "./CampusButton.vue?vue&type=style&index=0&id=3c0f3b2f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0f3b2f"],['__file',"src/components/list-items/CampusButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c0f3b2f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c0f3b2f', __exports__)) {
    api.reload('3c0f3b2f', __exports__)
  }
  
  module.hot.accept("./CampusButton.vue?vue&type=template&id=3c0f3b2f&scoped=true&ts=true", () => {
    api.rerender('3c0f3b2f', render)
  })

}


export default __exports__